module.exports = __webpack_public_path__ + "img/logo-circular-watermarked.8bc214ac.png";